import Button from 'antd/es/button';

export default Button;
